import { UserFlag } from "@/services/user/settings/flags/types";
import { z } from "zod";

export const UserFlag_Schema = z.enum(UserFlag);
